module.exports = __webpack_public_path__ + "static/img/mechanism-3.71d7b635.png";